// API Configuration
// export const API_BASE_URL = "https://middleware.caledontech.co";
export const API_BASE_URL = "https://webapi.rentgurus.com";
export const LANDING_PAGE_BASE_URL = "https://n8n-prod.caledontech.ca/webhook";
export const TERMS_API_URL = "https://n8n-prod.caledontech.ca/policies/terms_and_conditions";

export const API_ENDPOINTS = {
  LOCATIONS: "/location/search",
  LANDING_PAGE: "/landing-page",
  LANDING_URL: "/landing-link/search",

  //Prod Backend urls
  // LOCATION_SEARCH: "/location/search",
  AVAILABILITY_SEARCH: "/availability/search",
  GET_CACHED_SEARCH: "/availability/getSearch",
  CAR_OFFER_DETAILS: "/availability/getCarOffer",
  AVAILABILITY_REGISTER_SEARCH: "/availability/registerSearch",
  AVAILABILITY_SEARCH_BY_ID: "/availability/searchById",

  //RESERVATION
  PAYMENT_CREDENTIALS: "/payment/credentials",
  RESERVATION_CREATE: "/reservation/create",
  RESERVATION_PROCESS: "/reservation/process",
  RESERVATION_GET: "/reservation/get",
  CANCEL_CODE_GENERATE: "/reservation/code/generate",
  CANCEL_RESERVATION: "/reservation/cancel",
  RENTAL_TERMS: TERMS_API_URL,
  FISERV_CONFIG: "/payment/fiserv-config",
  STRIPE_CONFIG: "/stripe/config/config-key",
  NEWSLETTER_SUBSCRIPTION: "/newsletter/subscribe",
  NEWSLETTER_CONFIRM:"/newsletter/confirm",
  NEWSLETTER_UNSUBSCRIBE:"/newsletter/unsubscribe",
  COOKIE_CONSENT: "/cookie-consent",
  CONSENT_LAW: "/consent-law",
  FEEDBACK_VALIDATION: "/feedback/validate",
  FEEDBACK_SUBMISSION: "/feedback/submit",
  RENTAL_CONDITIONS: "/rental-conditions",
  RENTAL_CONDITIONS_RESERVATION: "/reservation/rental-conditions",
  CANCELLATION_POLICIES:"/availability/getCancellationPolicy",
  DETECT_IP:"/detect-country",
  SUPPORT_REQUEST:"/support-request"
};

// Default headers
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  "Accept": "application/json",
};
